import { Box, Button, Stack, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import CalculatorFilterMobileHeader from "./calculatorFilterMobileHeader";
import CalculatorStepper from '../../calculatorStepper';
import CalculatorMobileVehicleFilter from "./calculatorMobileVehicleFilter";
import CalculatorFIlterMobileCalender from "./calculatorFilterMobileCalander";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";

const CALCULATOR_HEADER = [
    {
        title: "Tour Pricing!",
        description: "Start by selecting your travel month and days — this helps us find the best rates for you."
    },
    {
        title: "Tour Pricing!",
        description: "Next, choose your preferred vehicle — so we can calculate the perfect rate for your journey."
    }
]

const CalculatorMobileFilter = ({
    defaultData, 
    moveToFormView, 
    buttonLoading,
    allowDistanceEdit
}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const [steps, setSteps] = useState(0);
    const [filterData, setFilterData] = useState({
        month: null,
        vehicle: null,
        days: 0,
        batta: true,
        distance: 0
    });

    useEffect(() => {
        console.log(defaultData);

        setFilterData({
            month: defaultData?.month,
            vehicle: defaultData?.vehicle,
            days: defaultData?.days, 
            batta: true,
            distance: defaultData?.distance
        });
    }, [defaultData]);
   
    const moveNextStep = useCallback(() => {
        if(steps === 0){
            setSteps(1);
        }
        else{
            console.log(filterData);
            moveToFormView(filterData.month, filterData.vehicle, filterData.days, filterData.batta, filterData.distance);
        }
    }, [steps, filterData]);
   
    const backPrevStep = useCallback(() => {
        setSteps(0);
    }, []);
   
    const setMonth = useCallback((month) => {
        setFilterData(prevObj => ({
            ...prevObj,
            month: month
        }))
    }, []);

    const setDays = useCallback((days) => {
        setFilterData(prevObj => ({
            ...prevObj,
            days: days
        }))
    }, []);

    const setDistance = useCallback((distance) => {
        setFilterData(prevObj => ({
            ...prevObj,
            distance: distance
        }))
    }, []);
   
    const setVehicle = useCallback((vehicle) => {
        setFilterData(prevObj => ({
            ...prevObj,
            vehicle: vehicle
        }))
    }, []);

    const setBatta = useCallback((batta) => {
        setFilterData(prevObj => ({
            ...prevObj,
            batta: batta
        }))
    }, []);

    const getStepperFillerCount = useCallback(() => {
        let count = 0;

        if(filterData?.distance > 0){
            count++;
        }

        if(filterData?.month){
            count++;
        }

        if(filterData?.vehicle){
            count++;
        }

        if(filterData?.days > 0){
            count++;
        }

        return count;
    }, [filterData]);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignContent='center'
                width='100%'
                pb={10}
                data-aos="fade-up"
            >
                <Box sx={{px: 2.5, pt: 3}}>
                    <Stack
                        direction='column'
                        justifyContent='start'
                        alignContent='center'
                        width='100%'
                        spacing={2}
                    >
                        <CalculatorFilterMobileHeader data={CALCULATOR_HEADER[steps]}/>

                        {/* Stepper */}
                        <Stack
                            direction='column'
                            justifyContent='center'
                            alignItems='center'
                            pt={2}
                        >
                            <CalculatorStepper step={getStepperFillerCount()}/>
                        </Stack>

                        {
                            steps === 0
                            ?
                            <CalculatorFIlterMobileCalender 
                                selectedDay={filterData.month} 
                                numberOfDays={filterData.days} 
                                activeDistance={filterData.distance}
                                setMonth={setMonth}
                                setDays={setDays}
                                setDistance={setDistance}
                                moveNextStep={moveNextStep}
                                allowDistanceEdit={allowDistanceEdit}
                            />
                            :
                            <CalculatorMobileVehicleFilter 
                                selectedVehicleName={filterData.vehicle} 
                                selectedBatta={filterData.batta} 
                                setVehicle={setVehicle}
                                moveNextStep={moveNextStep}
                                backPrevStep={backPrevStep}
                                setBatta={setBatta}
                                buttonLoading={buttonLoading}
                            />
                        }

                        <Stack
                            pb={5}
                        >
                            <Button 
                                variant="text" 
                                startIcon={<ArrowBackIcon />}
                                onClick={() => {navigate('/map');}}
                                sx={{
                                    textTransform: 'none',
                                    color: theme.palette.primary.main,
                                    backgroundColor: 'transparent',
                                    py: 2,
                                    '&: hover': {
                                        transform: 'scale(1.1)',
                                        backgroundColor: 'transparent'
                                    }
                                }}
                            >
                                Edit Map
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </Stack>
        </>
    );
}

export default CalculatorMobileFilter;